// Cek Tabung (operator): find a cylinder by serial number or EPC, or tap one in front of the Reader.
// Formal and calm: no exclamation marks; "Reader" and "Titik Distribusi" capitalised.

export const LOOKUP = {
  sub: (place: string) => `di ${place}`,
  searchLabel: 'Nomor seri atau EPC',
  placeholder: 'Nomor seri atau EPC',
  helper: 'Ketik nomor seri lengkap, angka nomor seri, atau awal EPC (min. 4 karakter).',
  short: (min: number) => `Ketik minimal ${min} karakter untuk mencari.`,
  clear: 'Hapus pencarian',
  initial: 'Hasil pencarian tampil di sini. Untuk cara tercepat, dekatkan tabung ke Reader lalu pilih dari daftar di atas.',
  noResult: 'Tidak ada tabung dengan nomor itu.',
  noResultHint: 'Ketik nomor seri lengkap (CNG-0001234), angka nomor serinya (1234), atau minimal 4 karakter awal EPC. Tabung yang belum terdaftar tidak muncul di sini.',
  results: 'Hasil pencarian',
  more: (n: number | null, exact: boolean) => (n == null ? 'Masih ada tabung lain yang cocok. Ketik lebih lengkap.' : `${exact ? '' : 'Lebih dari '}${n} tabung lain cocok. Ketik lebih lengkap.`),
  present: {
    title: 'Di depan Reader sekarang',
    none: 'Tidak ada tag di depan Reader.',
    noReader: 'Belum ada Reader di Titik Distribusi ini.',
    unregistered: 'Belum terdaftar',
    usedBefore: (serial: string) => `Pernah dipakai ${serial}`,
    retired: 'Tidak berlaku',
    stale: 'Daftar tag di depan Reader gagal dimuat.',
    retry: 'Coba lagi',
    tidMismatch: 'TID beda',
  },
  detail: {
    back: 'Kembali ke hasil',
    identity: 'Identitas',
    serial: 'Nomor seri',
    epc: 'EPC',
    test: 'Uji berkala',
    kind: 'Tipe',
    lastSeen: 'Terakhir terbaca',
    loadable: 'Boleh dimuat',
    yes: 'Ya',
    no: 'Tidak',
    position: 'Posisi sekarang',
    atSince: (place: string, since: string) => `Di ${place} sejak ${since}`,
    inTransit: (to: string | null, number: string) => (to ? `Dalam pengiriman ke ${to}, Surat Jalan ${number}` : `Dalam pengiriman, Surat Jalan ${number}`),
    inTransitNoDoc: 'Dalam pengiriman',
    missingSince: (since: string) => `Tidak ditemukan sejak ${since}`,
    missing: 'Tidak ditemukan',
    withConsumer: 'Di warga, diserahkan lewat tukar tabung',
    destroyed: 'Sudah dimusnahkan setelah gagal uji berkala. Tagnya tidak dapat dipakai lagi.',
    movements: 'Perpindahan terakhir',
    noMovements: 'Belum ada perpindahan tercatat.',
    full: 'Lihat detail lengkap',
    notFound: 'Tabung ini tidak ditemukan atau berada di luar wilayah akun Anda.',
    tidMismatch: 'TID chip berbeda dengan yang terdaftar: dugaan tag palsu.',
  },
} as const;
